import React from "react";

const Title1 = ({ mainTitle = "Main Title", subTitle = "Sub Title" }) => {
  return (
    <div className="my-5 title1">
      <center>
        <div className="dash mb-3"></div>
      </center>
      <h4 className="text-center ">{mainTitle}</h4>
      <h1 className="text-center display-2 fw-bolder">{subTitle}</h1>
    </div>
  );
};

export default Title1;
